import PropTypes from 'prop-types';
import React from 'react';

import style from '../../scss/components/charCounter.module.scss';

const CharCounter = ({ current, max, warnAt = 0.9 }) => {
    const ratio = max > 0 ? current / max : 0;
    const isAtLimit = current >= max;
    const isNearLimit = !isAtLimit && ratio >= warnAt;

    return (
        <div
            className={`
                ${style.charCounter}
                ${isNearLimit ? style.charCounterNear : ''}
                ${isAtLimit ? style.charCounterLimit : ''}
            `}
            aria-live="polite"
        >
            <span className={style.charCounterCurrent}>{current}</span>
            <span className={style.charCounterSep}>/</span>
            <span className={style.charCounterMax}>{max}</span>
        </div>
    );
};

CharCounter.propTypes = {
    current: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    warnAt: PropTypes.number,
};

CharCounter.defaultProps = {
    warnAt: 0.9,
};

export default CharCounter;
